import React, { ElementType, ComponentProps } from 'react';

const sizes = {
  small: 'min-h-4 min-w-4 h-4 w-4',
  medium: 'min-min-h-6 min-w-6 h-6 w-6',
  large: 'min-h-8 min-w-8 h-8 w-8',
};

export type HeroIconProps<T extends ElementType> = {
  icon: T;
  size?: keyof typeof sizes;
  className?: string;
  'aria-label'?: string;
} & ComponentProps<T>;

export const HeroIcon = <T extends ElementType>({
  icon: Icon,
  size = 'medium',
  className = '',
  ...props
}: HeroIconProps<T>) => {
  const sizeClass = sizes[size as keyof typeof sizes];

  return <Icon className={`${sizeClass} ${className}`} {...props} />;
};
